import { AuditService, type ListAuditLogsResponse, type LogFilter } from "#gen/audit/v1/audit_pb.js";
import type { PaginationArguments } from "#gen/common/v1/pagination_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { CallOptions, Client } from "@connectrpc/connect";

export class AuditClient {
	private client: Client<typeof AuditService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.audit || "/", AuditService, options);
	}

	async listAuditLogs(orgId: string, filter: LogFilter, pagination: PaginationArguments, lang = "en", opts?: CallOptions): Promise<ListAuditLogsResponse> {
		try {
			return await this.client.listAuditLogs({ filter, lang, orgId, pagination }, opts);
		} catch (e) {
			throw handleError(e);
		}
	}
}
